import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=1f91c8bc&scoped=true&"
import script from "./CategoryModal.vue?vue&type=script&lang=ts&"
export * from "./CategoryModal.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=1f91c8bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f91c8bc",
  null
  
)

export default component.exports